import { apiClient } from '../../../v4/core/apiClient';
import { createCallsheetApiHttp } from './callsheet.api.http';

export const myCallsheetApi = createCallsheetApiHttp(apiClient);
